import { Component, Injector, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, EntityOrderedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Dominio } from "src/app/model/dominio-operacao.model";
import { LabelRepasse, NaturezaJuridica } from "src/app/model/natureza-juridica.model";
import Utils from "src/app/shared/fgi-utils";
import { NaturezasJuridicasAceitasService } from "../../naturezas-juridicas-aceitas.service";
import { NaturezasJuridicasAceitasPesquisaComponent } from "../../pesquisa/naturezas-juridicas-aceitas-pesquisa.component"

@Component({
    selector: 'app-repasse-listagem',
    templateUrl: './repasse-listagem.component.html',
    styleUrls: ['./repasse-listagem.component.scss'],
    standalone: false
})
export class RepasseListagemComponent extends BaseEntityComponent<NaturezaJuridica> implements OnInit {

  @Input() public repasseBndes: NaturezaJuridica[] = [];
  @Input() public ideTranche: string;
  @Input() public permissaoGestorEnvio: boolean;
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public labels = LabelRepasse;
  public idNatureza: number;
  public idRestricao: string;
  public idN02: string;
  public idComplementoN02: string;
  public dadosDominio: Dominio;
  public naturezas: any;
  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;

  // override
  constructor(
    protected injector: Injector,
    protected repasseBndesService: NaturezasJuridicasAceitasService,
    private modalService: BnModalMessageService,
    private activatedRoute: ActivatedRoute,
    private NaturezasJuridicasAceitasPesquisaComponent: NaturezasJuridicasAceitasPesquisaComponent

  ) {
    super(repasseBndesService);
    this.config.bloquearTelaAoRecuperarModelo = true;
    this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
  }

  ngOnInit(): void {
    this.buscarNaturezas();
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  //Ordenação
  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.repasseBndes = this.repasseBndes.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  public label(item) {
    return this.labels.get(item);
  }

  public excluiRepasse(ideNatureza: number) {
    this.repasseBndesService.excluirRepasse(this.ideTranche, ideNatureza).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Natureza de repasse excluída com sucesso.'
      });
      this.NaturezasJuridicasAceitasPesquisaComponent.buscarTodosRepasses();
    })
  }
  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
      this.modalService.abrir('Inclusão de natureza de repasse', msg, tamanho, this.msgPersonalizada, this.botoesPersonalizados);
    }
  }

  close() {
    this.modalService.close();
  }

  dismiss() {
    this.modalService.dismiss();
  }
  public salvar() {
    let dto = new NaturezaJuridica();

    if (this.idNatureza) {
      dto.id = this.idNatureza;
    }
    if (this.idRestricao) {
      dto.restricaoTipoPessoa = this.idRestricao;
    }
    this.repasseBndesService.incluirRepasse(this.ideTranche, dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Natureza de repasse incluída com Sucesso.'
      });
      this.idNatureza = null;
      this.idRestricao = null;
      this.close();
      this.NaturezasJuridicasAceitasPesquisaComponent.buscarTodosRepasses();
    })
  }
  public buscarNaturezas() {
    this.repasseBndesService.buscarNaturezas().subscribe((res) => {
      this.naturezas = res
    })
  }

}


